import React from 'react';
import {
    Button,
    Modal,
    Alert,
} from 'react-bootstrap';

const DeleteUserModal = (props) => {
    const { deleteItem, handleClose, currentUser, handleDelete, filterOrgs } = props;

    return <Modal show={deleteItem.id !== undefined} onHide={handleClose}>
        <Modal.Dialog>
            <Modal.Header closeButton>
                <Modal.Title>Delete User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {currentUser.role === 'ORGANIZATION_ADMIN' && (
                    <p>
                        The user {deleteItem.firstName} {deleteItem.lastName} will be removed from your
                        organization(s). Do you want to continue?
                    </p>
                )}
                {currentUser.role !== 'ORGANIZATION_ADMIN' && (
                    <p>
                        All information about the user {deleteItem.firstName} {deleteItem.lastName} will
                        be lost. Do you want to continue?
                    </p>
                )}
                {currentUser.role === 'ORGANIZATION_ADMIN' &&
                    deleteItem.organizations?.filter(filterOrgs).length > 1 && (
                        <Alert variant="warning">
                            <p>
                                NOTE: The user have more organizations assigned, this action will remove them
                                from all.
                            </p>
                        </Alert>
                    )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn btn-custom white mr-3"
                    variant="outline-secondary"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button variant="outline-danger" onClick={handleDelete}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal.Dialog>
    </Modal>
}

export default DeleteUserModal;